import React, { Component } from "react";
import styled from "@emotion/styled";
import tw from "twin.macro";

import ButtonSolid from "../Button/ButtonSolid";

function encode(data) {
  const formData = new FormData();
  for (const key of Object.keys(data)) {
    formData.append(key, data[key]);
  }
  return formData;
}
const StyledForm = styled.div`
  [multiple],
  [type="date"],
  [type="datetime-local"],
  [type="email"],
  [type="month"],
  [type="number"],
  [type="password"],
  [type="search"],
  [type="tel"],
  [type="text"],
  [type="time"],
  [type="url"],
  [type="week"],
  select,
  textarea {
    ${tw`text-sm w-full text-gray-600 bg-white px-4 py-2.5 border border-solid border-gray-300 rounded-sm focus:border-transparent focus:outline-none focus:ring-3 focus:ring-primary-600 focus:ring-opacity-30 transition-colors duration-300 ease-linear`}
  }
`;

export default class Form extends Component {
  constructor(props) {
    super(props);
    this.state = { isValidated: false };
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    fetch("/", {
      method: "POST",
      body: encode({
        "form-name": form.getAttribute("name"),
        ...this.state,
      }),
    })
      .then(
        () =>
          (document.getElementById("application-form-ajax-response").innerHTML =
            "Thank you for contacting us! We will get in touch with you shortly."),
        form.remove(),
        (window.dataLayer = window.dataLayer || []),
        window.dataLayer.push({
          event: "applicationFormSubmission",
        })
      )
      .catch((error) => alert(error));
  };

  render() {
    return (
      <StyledForm>
        <div id="application-form-ajax-response" className="text-gray-600"></div>
        <form
          name="Application - Slideout"
          method="post"
          action=""
          data-netlify="true"
          data-netlify-honeypot="bot-field"
          enctype="multipart/form-data"
          onSubmit={this.handleSubmit}
        >
          {/* The `form-name` hidden field is required to support form submissions without JavaScript */}
          <input type="hidden" name="form-name" value="Application - Slideout" />
          <div hidden>
            <label>
              Don’t fill this out: <input name="bot-field" onChange={this.handleChange} />
            </label>
          </div>

          <div className="mb-5">
            <label
              className="font-body text-sm font-semibold text-gray-800 block mb-1"
              htmlFor="name"
            >
              Name
            </label>
            <input type="text" name="name" onChange={this.handleChange} required={true} />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 md:gap-x-6 w-full">
            <div className="mb-5">
              <label
                className="font-body text-sm font-semibold text-gray-800 block mb-1"
                htmlFor="phone"
              >
                Phone Number
              </label>
              <input type="tel" name="phone" onChange={this.handleChange} required={true} />
            </div>
            <div className="mb-5">
              <label
                className="font-body text-sm font-semibold text-gray-800 block mb-1"
                htmlFor="email"
              >
                Email Address
              </label>
              <input type="email" name="email" onChange={this.handleChange} required={true} />
            </div>
          </div>

          {/* <div className="mb-5">
            <label
              className="font-body text-sm font-semibold text-gray-800 block mb-1"
              htmlFor="what-can-we-help-you-with"
            >
              What Can We Help You With?
            </label>
            <select name="what-can-we-help-you-with" onBlur={this.handleChange} required={true}>
              <option value="">Select one...</option>
              <option value="Business">Business</option>
              <option value="Construction">Construction</option>
              <option value="Criminal Defense">Criminal Defense</option>
              <option value="DUI / DWAI">DUI / DWAI</option>
              <option value="Elder Law">Elder Law</option>
              <option value="Estate Planning">Estate Planning</option>
              <option value="Family Law">Family Law</option>
              <option value="Guardianships & Conservatorships">
                Guardianships & Conservatorships
              </option>

              <option value="Medicaid">Medicaid</option>
              <option value="Personal Injury">Personal Injury</option>
              <option value="Probate">Probate</option>
              <option value="Real Estate">Real Estate</option>
              <option value="Other">Other</option>
            </select>
          </div> */}

          <div className="mb-5">
            <label
              className="font-body text-sm font-semibold text-gray-800 block mb-1"
              htmlFor="message"
            >
              Message
            </label>
            <textarea
              className="textarea"
              name="message"
              onChange={this.handleChange}
              rows="4"
              required={true}
            />
          </div>
          <div className="mb-6 w-full">
            <label className="font-body text-sm font-semibold text-gray-800 block mb-1">
              <span className="">Resume:</span>
              <input
                name="resume"
                type="file"
                className="w-full border-[1px] border-gray-300 p-4"
                onChange={(e) =>
                  this.setState((prev) => ({
                    ...prev,
                    resume: e.target.files[0],
                  }))
                }
              />
            </label>
          </div>
          <ButtonSolid type="submit" text="Send" />
        </form>
      </StyledForm>
    );
  }
}
